/*
https://splidejs.com/guides/getting-started/
*/
import '@splidejs/splide/css/core';
import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".gallery__slider");
  const sliderCounter = document.querySelector( ".gallery__slider .slider-counter" );

  if (slider) {
    var splide = new Splide(".gallery__slider", {
      type: "slide",
      speed: 1000,
      arrows: true,
      pagination: false,
      perPage: 1,
      breakpoints: {
        640: {
          perPage: 1,
        },
      },
      perMove: 1,
      rewind: true,
      gap: 15,
      waitForTransition: false,
    });

    splide.on("moved", function (newIndex) {
      // calculate number of slides
      let endRange = newIndex + splide.options.perPage;
      // don't exceed total number of slides
      endRange = endRange > splide.length ? splide.length : endRange;
      // update counter
      sliderCounter.innerHTML = `${endRange}/${splide.length}`;
    });

    splide.mount();

    let initialEndRange =
      splide.options.perPage > splide.length
        ? splide.length
        : splide.options.perPage;
    sliderCounter.innerHTML = `${initialEndRange}/${splide.length}`;
  }
});
